import { theme } from '@pocketlaw/tetris';
import { css } from 'styled-components';
export const userAvatar = css `
  .ck-user__name {
    font-weight: ${theme.fontWeight.medium};
  }
`;
